import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, } from '@angular/common/http';
import { Observable, Subject, } from 'rxjs';
import { map, catchError, } from 'rxjs/operators';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { GeneralService } from 'src/app/service/general.service';
import { ErrorService } from 'src/app/error.service';
import { GetMonitor } from './client-monitorlist.model';
@Injectable({
  providedIn: 'root'
})
export class ClientMonitorService extends Subject<DataStateChangeEventArgs>{
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    })
  };
  constructor(private http: HttpClient, public general: GeneralService, public errorService: ErrorService) {
    super();
  }
  public outputValuesClientMonitorDetails(state: GetMonitor): void {
    this.getClientMonitorDetails(state).subscribe(x => super.next(x));
  }
  getClientMonitorDetails(state?: GetMonitor): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Client/GetClientMonitorList", state)
      .pipe(map(
        (response: any) => (<any>{
          count: response['count'],
          result: response['result']
        }))).pipe(map((e: any) => {
          return e;
        })
        )
  }
  public outputValuesEmployeeMonitorDetails(state: GetMonitor): void {
    this.getEmployeeMonitorDetails(state).subscribe(x => super.next(x));
  }
  getEmployeeMonitorDetails(state?: GetMonitor): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/EmployeeMonitor/getEmployeeMonitor", state)
      .pipe(map(
        (response: any) => (<any>{
          count: response['count'],
          result: response['result']
        }))).pipe(map((e: any) => {
          e.result?.map(e => e.statusName = (e.statusName == '' || e.statusName == undefined || e.statusName == null) ? 'Active' : e.statusName)
          return e;
        })
        )
  }
}


